import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

@Component({
  selector: "app-office-expance-list",
  templateUrl: "./office-expance-list.component.html",
  styleUrls: ["./office-expance-list.component.css"],
})
export class OfficeExpanceListComponent implements OnInit {
  users: any = [];
  isAdmin: boolean = false;
  isSuperSupervisor: boolean = false;
  page = 1;
  limit = 10;
  totalRecords = 0;
  searchText = "";
  fromDate = "";
  toDate = "";
  totalPages = 0;
  currentPage = 1;
  subCat;
  @ViewChild("paginator") paginator: MatPaginator;
  dataSource = new MatTableDataSource<any>([]);
  isLoading = false;

  displayedColumns: any = [
    "SupervisorName",
    "expenseSubCategory",
    "companyName",
    "totalExpenseAmount",
    "expenseDate",
    "expenseDescription",
    "action",
  ];
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {}
  userSessionData;

  ngOnInit(): void {
    this.getAllExpense();
    this.userSessionData = JSON.parse(sessionStorage.getItem("userSession"));

    if (this.userSessionData?.user_role_id?.[0] === 1) {
      this.isAdmin = true;
    } else if (this.userSessionData?.user_role_id?.includes(7)) {
      this.isSuperSupervisor = true;
    }
  }

  getAllExpense() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.spinner.show();

    this.superAdminService
      .getExpensesByCategory(
        "Office Expense",
        this.searchText,
        this.page,
        this.limit,
        this.fromDate,
        this.toDate
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.isLoading = false;

          if (res.status) {
            this.users = res.data || [];
            this.totalRecords = res.totalRecords || 0;
            this.totalPages = res.totalPages || 0;
            this.currentPage = res.currentPage || 1;
            this.limit = res.limit || this.limit;

            this.dataSource.data = this.users;

            // sync paginator
            if (this.paginator) {
              this.paginator.length = this.totalRecords;
              this.paginator.pageIndex = this.currentPage - 1;
              this.paginator.pageSize = this.limit;
            }
          } else {
            this.toastr.error(res.message);
          }
        },
        () => {
          this.isLoading = false;
          this.spinner.hide();
        }
      );
  }

  // emitdata(params) {
  //   sessionStorage.setItem("userdata", JSON.stringify(params));
  // }

  deleteExpense(_id) {
    if (this.superAdminService.deleteDailogBox()) {
      this.superAdminService.deleteExpense(_id).subscribe(
        (res: { status: any; message: any; authorization: any; code: any }) => {
          if (res.status == true) {
            this.toastr.success(res.message);
            //this.router.navigateByUrl('/user/userManagement');
            this.getAllExpense();
          } else {
            if (res.status == 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.error(res.message);
            }
          }
        },
        (error) => {}
      );
    }
  }
  filterData(value: string) {
    this.searchText = value.trim();
    this.page = 1;
    this.getAllExpense();
  }

  exportToExcel() {
    this.spinner.show();

    this.superAdminService
      .exportExpensesByCategory(
        "Office Expense", // category
        this.searchText, // search
        this.fromDate, // from date
        this.toDate // to date
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();

          if (!res.status || !res.data || !res.data.length) {
            this.toastr.warning("No data available to export");
            return;
          }

          const exportData = res.data.map((item, index) => ({
            "S.No": index + 1,
            "Supervisor Name": item.supervisorName || "",
            "Expense Category": item.expenseSubCategory || "",
            "Company Name": item.companyName || "",
            "Expense Amount": item.totalExpenseAmount || 0,
            "Expense Date": item.expenseDate
              ? new Date(item.expenseDate).toLocaleDateString("en-GB")
              : "",
            "Expense Description": item.expenseDescription || "",
          }));

          const worksheet: XLSX.WorkSheet =
            XLSX.utils.json_to_sheet(exportData);

          const workbook: XLSX.WorkBook = {
            Sheets: { "Office Expense": worksheet },
            SheetNames: ["Office Expense"],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
          });

          saveAs(blob, `Office_Expense_${new Date().getTime()}.xlsx`);
        },
        () => {
          this.spinner.hide();
          this.toastr.error("Export failed");
        }
      );
  }

  onPageChange(event: any) {
    const newPage = event.pageIndex + 1;
    const newLimit = event.pageSize;

    if (this.page === newPage && this.limit === newLimit) {
      return;
    }

    this.page = newPage;
    this.limit = newLimit;

    this.getAllExpense();
  }

  onDateChange(event: any, type: "from" | "to"): void {
    if (type === "from") {
      this.fromDate = event.target.value;
    } else {
      this.toDate = event.target.value;
    }

    // reset pagination
    this.page = 1;
    this.currentPage = 1;

    this.getAllExpense();
  }

  clearFilters() {
    this.searchText = "";
    this.fromDate = "";
    this.toDate = "";

    this.page = 1;
    this.currentPage = 1;

    // clear inputs visually
    const fromInput = document.getElementById("fromDate") as HTMLInputElement;
    const toInput = document.getElementById("toDate") as HTMLInputElement;
    const searchInput = document.querySelector(
      "input.search-box"
    ) as HTMLInputElement;

    if (fromInput) fromInput.value = "";
    if (toInput) toInput.value = "";
    if (searchInput) searchInput.value = "";

    this.paginator?.firstPage();
    this.getAllExpense();
  }
}
